import { Building2 } from "lucide-react";
import { usePortalCompany } from "@/hooks/usePortalCompany";

const PortalCompanySwitcher = () => {
  const { canSwitchPortalCompany, portalCompanyOptions, companyId, setPortalCompanyId } = usePortalCompany();

  if (!canSwitchPortalCompany || portalCompanyOptions.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 rounded-2xl border border-primary-foreground/10 bg-primary-foreground/[0.03] p-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-primary-foreground/5 text-primary-foreground/60">
            <Building2 className="h-4 w-4" />
          </div>
          <div>
            <p className="font-body text-[11px] font-bold uppercase tracking-[0.24em] text-primary-foreground/40">
              Client Demo View
            </p>
            <p className="mt-1 font-body text-sm text-primary-foreground/70">
              Choose the company experience you want to present.
            </p>
          </div>
        </div>

        <div className="w-full lg:max-w-sm">
          <label className="mb-2 block font-body text-[11px] font-bold uppercase tracking-[0.18em] text-primary-foreground/35">
            Active company
          </label>
          <select
            value={companyId ?? ""}
            onChange={(event) => setPortalCompanyId(event.target.value || null)}
            className="w-full rounded-xl border border-primary-foreground/10 bg-background px-4 py-3 font-body text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          >
            {portalCompanyOptions.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default PortalCompanySwitcher;